module.exports = __webpack_public_path__ + "static/media/005.36bc5cd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/005.jpg
// module id = 478
// module chunks = 0